import { render, staticRenderFns } from "./FutureCoinSelect.vue?vue&type=template&id=2e4c0e49&scoped=true&"
import script from "./FutureCoinSelect.vue?vue&type=script&lang=js&"
export * from "./FutureCoinSelect.vue?vue&type=script&lang=js&"
import style0 from "./FutureCoinSelect.vue?vue&type=style&index=0&id=2e4c0e49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c0e49",
  null
  
)

export default component.exports